export default {
  en: {
    period: 'Period',
  },
  ru: {
    period: 'Период',
  },
  de: {
    period: 'Zeitraum',
  },
  pt: {
    period: 'Período',
  },
  fr: {
    period: 'Période',
  },
  es: {
    period: 'Período',
  },
};
